module.exports = __webpack_public_path__ + "background2.52fd70c814ccbf027e9d";


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/assets/background2.png
// module id = ../../../../../src/assets/background2.png
// module chunks = styles